"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ITEMS_COUNTER = void 0;
const ITEMS_COUNTER = exports.ITEMS_COUNTER = 'items-counter';
